var exhInsideOut1 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-insideout/exhInsideOut1.jpg';
var exhInsideOut2 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-insideout/exhInsideOut2.jpg';
var exhInsideOut3 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-insideout/exhInsideOut3.jpg';
var exhInsideOut4 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-insideout/exhInsideOut4.jpg';
var exhInsideOut5 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-insideout/exhInsideOut5.jpg';
var exhInsideOut6 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-insideout/exhInsideOut6.jpg';
var exhInsideOut7 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-insideout/exhInsideOut7.jpg';
var exhInsideOut8 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-insideout/exhInsideOut8.jpg';
var exhInsideOut9 = 'https://lorraineshemeshsiteimgs.s3.us-east-2.amazonaws.com/exhibition-insideout/exhInsideOut9.jpg';


export const allImagesDesktopOrderExhInsideOut = [
    [/*COLUMN 1*/
        [
            {
                name: exhInsideOut1,
                captionln1: "The Gerald Peters Gallery interior in Manhattan during the solo exhibition, <b>Inside Out</b>.",
                captionln2: "",
                captionln3: "",
                link: "insideout1"
            },
        ],
        [
            {
                name: exhInsideOut2,
                captionln1: "The exhibition catalogue for the solo exhibition, <b>Inside Out</b>, at Gerald Peters Gallery.",
                captionln2: "",
                captionln3: "",
                link: "insideout2"
            },
        ],
        [
            {
                name: exhInsideOut3,
                captionln1: "The Gerald Peters Gallery interior in New York City during the solo exhibition, <b>Inside Out</b>.",
                captionln2: "",
                captionln3: "",
                link: "insideout3"
            },
        ]
    ],
    [/*COLUMN 2*/
        [
            {
                name: exhInsideOut4,
                captionln1: "The exhibition catalogue for the solo exhibition, <b>Inside Out</b>, at Gerald Peters Gallery.",
                captionln2: "",
                captionln3: "",
                link: "insideout4"
            },
        ],
        [
            {
                name: exhInsideOut5,
                captionln1: "The Gerald Peters Gallery interior in New York City during the solo exhibition, <b>Inside Out</b>.",
                captionln2: "",
                captionln3: "",
                link: "insideout5"
            },
        ],
        [
            {
                name: exhInsideOut6,
                captionln1: "The Gerald Peters Gallery interior in New York City during the solo exhibition, <b>Inside Out</b>.",
                captionln2: "",
                captionln3: "",
                link: "insideout6"
            }
        ]
    ],
    [/*COLUMN 3*/
        [
            {
                name: exhInsideOut7,
                captionln1: "The Gerald Peters Gallery interior in New York City during the solo exhibition, <b>Inside Out</b>.",
                captionln2: "",
                captionln3: "",
                link: "insideout7"
            }
        ],
        [
            {
                name: exhInsideOut8,
                captionln1: "The Gerald Peters Gallery interior in New York City during the solo exhibition, <b>Inside Out</b>.",
                captionln2: "",
                captionln3: "",
                link: "insideout8"
            },
        ],
        [
            {
                name: exhInsideOut9,
                captionln1: "The Gerald Peters Gallery interior in New York City during the solo exhibition, <b>Inside Out</b>.",
                captionln2: "",
                captionln3: "",
                link: "insideout9"
            }
        ]
    ]          
]

export const allImagesMobileOrderExhInsideOut = [
    [{
        name: exhInsideOut1,
        captionln1: "The Gerald Peters Gallery interior in Manhattan during the solo exhibition, <b>Inside Out</b>.",
        captionln2: "",
        captionln3: "",
        link: "insideout1"
    },
    {
        name: exhInsideOut2,
        captionln1: "The exhibition catalogue for the solo exhibition, <b>Inside Out</b>, at Gerald Peters Gallery.",
        captionln2: "",
        captionln3: "",
        link: "insideout2"
    },
    {
        name: exhInsideOut3,
        captionln1: "The Gerald Peters Gallery interior in New York City during the solo exhibition, <b>Inside Out</b>.",
        captionln2: "",
        captionln3: "",
        link: "insideout3"
    },
    {
        name: exhInsideOut4,
        captionln1: "The exhibition catalogue for the solo exhibition, <b>Inside Out</b>, at Gerald Peters Gallery.",
        captionln2: "",
        captionln3: "",
        link: "insideout4"
    },
    {
        name: exhInsideOut5,
        captionln1: "The Gerald Peters Gallery interior in New York City during the solo exhibition, <b>Inside Out</b>.",
        captionln2: "",
        captionln3: "",
        link: "insideout5"
    },
    {
        name: exhInsideOut6,
        captionln1: "The Gerald Peters Gallery interior in New York City during the solo exhibition, <b>Inside Out</b>.",
        captionln2: "",
        captionln3: "",
        link: "insideout6"
    },
    {
        name: exhInsideOut7,
        captionln1: "The Gerald Peters Gallery interior in New York City during the solo exhibition, <b>Inside Out</b>.",
        captionln2: "",
        captionln3: "",
        link: "insideout7"
    },
    {
        name: exhInsideOut8,
        captionln1: "The Gerald Peters Gallery interior in New York City during the solo exhibition, <b>Inside Out</b>.",
        captionln2: "",
        captionln3: "",
        link: "insideout8"
    },
    {
        name: exhInsideOut9,
        captionln1: "The Gerald Peters Gallery interior in New York City during the solo exhibition, <b>Inside Out</b>.",
        captionln2: "",
        captionln3: "",
        link: "insideout9"
    }]      
]
